import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import { useNavigate } from 'react-router-dom'
import styles from "../../assets/styles/labtest.module.css"
import MedicalRoomTable from '../../components/medicalRooms/MedicalRoomTable'
import {  useDownloadExcel } from 'react-export-table-to-excel';
import { getMedicalRoomApi } from '../../utils/api/services'
import { toast } from 'react-toastify'
import moment from 'moment'

const MedicalRooms = () => {
    const [searchValue, setSearchValue] = useState('')
    const [filterValue, setFilterValue] = useState<FilterTypes>({
        fromDate: null,
        toDate: null
    })
    const [loading, setLoading] = useState(false)
    const [MedicalRoomData, setMedicalRoomData] = useState<ChecklistItem[] | []>([]);
    const navigate = useNavigate();
    const tableRef = useRef<HTMLTableElement>(null);

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Medical Room checklist',
        sheet: 'checklist'
    })

    const handleDateChange = (value: Date | null, name: string) => {
        const momentValue = value !== null ? moment(value)?.format('DD-MM-YYYY') : null;
        setFilterValue({
            ...filterValue,
            [name]: momentValue
        })
    }
    const handleSearchValue = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
    }

    const fetchMedicalRoomData = async (data?: { searchQuery?: string, fromDate?: Date | null, toDate: Date | null }) => {
        try {
            setLoading(true)
            const result = await getMedicalRoomApi(data);
            if (result?.success) {
                setLoading(false)
                setMedicalRoomData(result?.checklistItems)
            }
            else {
                setLoading(false)
                setMedicalRoomData([])
            }
        } catch (error: any) {
            setLoading(false)
            toast.error(error?.data?.errors || error?.message);
        }
    }

    useEffect(() => {
        if (searchValue) {
            const cleanUpFun = setTimeout(() => {
                fetchMedicalRoomData({ searchQuery: searchValue, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
            }, 1000);
            return () => clearInterval(cleanUpFun)
        }
        else {
            fetchMedicalRoomData({ searchQuery: searchValue ? searchValue : undefined, fromDate: filterValue?.fromDate, toDate: filterValue?.toDate })
        }
    }, [searchValue, filterValue]);


    const handleClone = (item: ChecklistItem) => {
        navigate('/medicalRooms/clone', {
            state: {
                date: item?.date,
                staffName: item?.staffName,
                isClone: true
            }
        })
    }
    const handleView = (item: ChecklistItem) => {
        navigate('/medicalRooms/view', {
            state: {
                date: item?.date,
                staffName: item?.staffName,
                isView: true
            }
        })
    }

    return (
        <CustomContainer>
            <div className='AllPageMain'>
                <div className='HeadAndButton'>
                    <h2>Medical Room checklist </h2>
                    <div className='flex items-center gap-6'>
                        <button className='fillButton' onClick={() => navigate('/medicalRooms/add')}>New Entry +</button>
                        <button className='outLineBtn' onClick={onDownload}>Export Data</button>
                    </div>
                </div>
                <div className={styles.labTestMain}>
                    <MedicalRoomTable
                        MedicalRoomData={MedicalRoomData}
                        loading={loading}
                        searchValue={searchValue}
                        ref={tableRef}
                        handleSearchValue={handleSearchValue}
                        filterValue={filterValue}
                        handleClone={handleClone}
                        handleView={handleView}
                        handleDateChange={handleDateChange}
                    />
                </div>
            </div>
        </CustomContainer>
    )
}

export default MedicalRooms